import LayoutLogin from '~componentes/LayoutLogin.vue';
import RecuperarSenha from './RecuperarSenha.vue';

export default {
  path: '/recuperar-senha',
  component: LayoutLogin,
  children: [
    {
      path: '',
      component: RecuperarSenha,
      name: 'recuperarsenha',
    },
  ]
}





// WEBPACK FOOTER //
// ./FrontEnd/modulos/recuperar-senha/rotas.js